'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactCssModules = require('react-css-modules');

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _reactTooltip = require('react-tooltip');

var _reactTooltip2 = _interopRequireDefault(_reactTooltip);

var _config = require('../../config');

var _config2 = _interopRequireDefault(_config);

var _ = require('../');

var _CompanyIsWff = require('./CompanyIsWff.css');

var _CompanyIsWff2 = _interopRequireDefault(_CompanyIsWff);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CompanyIsWff = (_dec = (0, _reactCssModules2.default)(_CompanyIsWff2.default, { allowMultiple: true }), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(CompanyIsWff, _Component);

  function CompanyIsWff(props) {
    (0, _classCallCheck3.default)(this, CompanyIsWff);

    var _this = (0, _possibleConstructorReturn3.default)(this, (CompanyIsWff.__proto__ || (0, _getPrototypeOf2.default)(CompanyIsWff)).call(this, props));

    var sources = _config2.default.wffCompanySources && _config2.default.wffCompanySources[props.company.company_id] ? _config2.default.wffCompanySources[props.company.company_id].slice(1) : null;
    _this.state = {
      company_sources: sources
    };
    return _this;
  }

  (0, _createClass3.default)(CompanyIsWff, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      if (!this.state.company_sources) return null;
      var iconNw = require('../../../static/images/icn-nw-no-circle-black.svg');
      var iconCm = require('../../../static/images/icn-cm-no-circle-black.svg');
      var iconMmc2 = require('../../../static/images/icn-mmc-black.svg');
      var iconNw2 = require('../../../static/images/icn-nw.svg');
      var iconCm2 = require('../../../static/images/icn-cm.svg');

      return _react2.default.createElement(
        'div',
        { styleName: 'family-modal' },
        _react2.default.createElement(
          'div',
          { styleName: 'icon-row' },
          this.props.company.is_mmc ? _react2.default.createElement(_.CompanyIsFlag, { icon: iconMmc2, title: 'Military contractor' }) : null,
          this.props.company.is_nw ? _react2.default.createElement(_.CompanyIsFlag, { icon: iconNw2, title: 'Nuclear weapons', color: 'red' }) : null,
          this.props.company.is_cm ? _react2.default.createElement(_.CompanyIsFlag, { icon: iconCm2, title: 'Controversial weapons', color: 'red' }) : null
        ),
        _react2.default.createElement(
          'p',
          null,
          _react2.default.createElement(
            'span',
            { style: { fontWeight: '800' } },
            'Source data:'
          ),
          ' Below is a list of pension funds and asset managers that list this company for exclusion on the basis of involvement with military weapons. Exclusions for nuclear weapons or controversial weapons are marked with an icon.'
        ),
        _react2.default.createElement(
          'div',
          { styleName: 'sources-ul' },
          this.state.company_sources.map(function (e, i) {
            var source_idx = e[0];
            var special_str = e.length > 1 ? e[1].split('') : null;
            var source_dat = _config2.default.wffSources[source_idx];
            var source_shortname = source_dat[0];
            var source_desc = source_dat[1];
            var source_name = source_dat[2];
            var source_filename = source_dat[3];
            if (source_filename.slice(-3) === 'pdf' || source_filename.slice(-4) === 'xlsx') {
              source_filename = _config2.default.links.exclusionListsS3 + source_filename;
            }
            return _react2.default.createElement(
              'div',
              {
                key: 'company-source-' + _this2.props.company.company_id + '-' + i,
                styleName: 'source-li'
              },
              _react2.default.createElement(
                'div',
                { styleName: 'source-shortname' },
                _react2.default.createElement(
                  'div',
                  null,
                  _react2.default.createElement(
                    'div',
                    null,
                    _react2.default.createElement(
                      'span',
                      {
                        style: { display: 'inline-block', width: '30px;' },
                        'data-multiline': true,
                        'data-effect': 'solid',
                        'data-tip': "<div style='max-width:150px;'>" + source_desc + '</div>',
                        'data-for': 'source-tooltip-' + i,
                        'data-place': 'right',
                        'data-html': true
                      },
                      _react2.default.createElement(_.LinkIcon, { faclass: 'fa-info-circle' })
                    ),
                    '\xA0\xA0\xA0',
                    _react2.default.createElement(
                      'b',
                      null,
                      source_shortname
                    )
                  ),
                  _react2.default.createElement(
                    'div',
                    null,
                    _react2.default.createElement(
                      _.Link,
                      {
                        to: source_filename,
                        title: source_name
                      },
                      source_name
                    )
                  )
                ),
                _react2.default.createElement(
                  'div',
                  null,
                  special_str && special_str.includes('n') ? _react2.default.createElement('img', {
                    styleName: 'detail-icon-holding',
                    src: iconNw,
                    alt: 'Nuclear weapons',
                    'data-multiline': true,
                    'data-effect': 'solid',
                    'data-tip': '<div style=\'max-width:150px;\'>Flagged for nuclear weapons</div>',
                    'data-for': 'source-icon1-' + i,
                    'data-place': 'left',
                    'data-html': true

                  }) : null,
                  special_str && special_str.includes('c') ? _react2.default.createElement('img', {
                    styleName: 'detail-icon-holding',
                    src: iconCm,
                    alt: 'Controversial weapons',
                    'data-multiline': true,
                    'data-effect': 'solid',
                    'data-tip': '<div style=\'max-width:150px;\'>Flagged for controversial weapons</div>',
                    'data-for': 'source-icon2-' + i,
                    'data-place': 'left',
                    'data-html': true
                  }) : null
                )
              ),
              _react2.default.createElement(_reactTooltip2.default, { id: 'source-tooltip-' + i }),
              _react2.default.createElement(_reactTooltip2.default, { id: 'source-icon1-' + i }),
              _react2.default.createElement(_reactTooltip2.default, { id: 'source-icon2-' + i })
            );
          })
        )
      );
    }
  }]);
  return CompanyIsWff;
}(_react.Component), _class2.propTypes = {
  company: _react.PropTypes.object.isRequired
}, _temp)) || _class);
exports.default = CompanyIsWff;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/CompanyIsPanels/CompanyIsWff.js
// module id = 1385
// module chunks = 0